export const EXPIRATION_TIME_MS = 15 * 60 * 1000;
export const FIRESTORE_USERS_TABLE = 'users';

export const GTMUrlKeyBegin = 'add_to_cart';
export const GTMUrlKeyPurchase = 'purchase';
export const GTMDefaultAffiliation = 'Booking Platform';

export enum GTMEvent {
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  ViewItem = 'view_item',
  SelectPromotion = 'select_promotion',
  AddPaymentInfo = 'add_payment_info',
  SearchSubmit = 'search_submit',
}
